var map = {
	"./ambulance_11347.png": "760c",
	"./background.jpg": "b13e",
	"./background_12165.png": "5da5",
	"./ball_11354.png": "e3a1",
	"./bowl_11361.png": "1d2b",
	"./cat_11456.png": "3724",
	"./cat_11858.png": "3d00",
	"./cat_food_11363.png": "eac1",
	"./credit_card.png": "56ee",
	"./dog_11544.png": "4a96",
	"./dog_11868.png": "d254",
	"./dog_11878.png": "fa5b",
	"./dog_12157.png": "5a11",
	"./dog_12173.png": "b3df",
	"./envelope.png": "7c82",
	"./leash_11450.png": "7c81",
	"./pets_12128.png": "1b63",
	"./pills_11446.png": "0139",
	"./pin.png": "62e4",
	"./shampoo_11370.png": "db99",
	"./syringe_11448.png": "d9a3",
	"./telephone.png": "812e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f15";